import React, { useRef } from 'react'
import { FiRepeat } from 'react-icons/fi'
import styles from './ContextInfo.module.sass'
import { useState } from 'react';
import { useEffect } from 'react';
import TextInput from '../../../../components/TextInput';
import File from '../../../../components/File';
import Switch from '../../../../components/Switch';
import Popover2 from '../../../../components/Popover2';
import Popover from '../../../../components/Popover';
import { useDispatch, useSelector } from "react-redux";
import { fetchCards } from '../../../../app/cards/cards.slice';
import Modal from '../../../../components/Modal';
import CardPreview from '../../../../components/CardPreview';
import classNames from "classnames";
import dayjs from 'dayjs';

const ContextInfo = ({
    info,
    setInfo
}) => {

    const myRefs = useRef([]);
    const dispatch = useDispatch();

    const [characters, setCharacters] = useState('')
    const [pinyin, setPinyin] = useState('')
    const [tone, setTone] = useState('')

    const [tradES, setTradES] = useState('')
    const [tradEN, setTradEN] = useState('')
    const [tradFR, setTradFR] = useState('')
    const [tradRU, setTradRU] = useState('')
    const [tradPT, setTradPT] = useState('')

    const [activeES, setActiveES] = useState(false)
    const [activeEN, setActiveEN] = useState(false)
    const [activeFR, setActiveFR] = useState(false)
    const [activeRU, setActiveRU] = useState(false)
    const [activePT, setActivePT] = useState(false)

    const [pinyinActive, setPinyinActive] = useState(false)
    const [toneActive, setToneActive] = useState(false)

    const [file, setFile] = useState('')
    const [fileURL, setFileURL] = useState('')

    const [visibleModalImportText, setVisibleModalImportText] = useState(false)
    const [textImport, setTextImport] = useState('')

    const [isContextValidated, setIsContextValidated] = useState(false)

    const [contextValidatedBy, setContextValidatedBy] = useState('')
    const [contextValidatedAt, setContextValidatedAt] = useState('')

    const [isTextProcessChanged, setIsTextProcessChanged] = useState(false)

    const handleAddImportText = () => {
        
    }

    useEffect(() => {
        setCharacters(info?.character)
        setPinyin(info?.pinyin)
        setTone(info?.pinyinTone)

        setPinyinActive(info?.pinyinExample?.active)
        setToneActive(info?.pinyinToneExample?.active)

        setTradES(info?.translations?.filter(c => c?.lang === 'es')?.[0]?.trans)
        setTradEN(info?.translations?.filter(c => c?.lang === 'en')?.[0]?.trans)
        setTradFR(info?.translations?.filter(c => c?.lang === 'fr')?.[0]?.trans)
        setTradRU(info?.translations?.filter(c => c?.lang === 'ru')?.[0]?.trans)
        setTradPT(info?.translations?.filter(c => c?.lang === 'pt')?.[0]?.trans)

        setActiveES(info?.translations?.filter(c => c?.lang === 'es')?.[0]?.active)
        setActiveEN(info?.translations?.filter(c => c?.lang === 'en')?.[0]?.active)
        setActiveFR(info?.translations?.filter(c => c?.lang === 'fr')?.[0]?.active)
        setActiveRU(info?.translations?.filter(c => c?.lang === 'ru')?.[0]?.active)
        setActivePT(info?.translations?.filter(c => c?.lang === 'pt')?.[0]?.active)

        if(info?.analyzed){
            setIsContextValidated(info?.analyzed?.active)
            setContextValidatedBy(info?.analyzed?.updatedBy)
            setContextValidatedAt(info?.analyzed?.lastUpdate)

            if(!textImport && !setIsTextProcessChanged){
                console.log("hola")
                setIsTextProcessChanged(true)
                setInfo({
                    ...info,
                    analyzed: {
                        ...info.analyzed,
                        processRawText: false
                    }
                })
            }
        }

        if(info?.fileExtra){
            setFile(info?.fileExtra)
            setFileURL(URL.createObjectURL(info?.fileExtra))
        }

        if(!info?.translations){
            setInfo({
                ...info,
                translations: [
                    {
                        lang: 'es',
                        active: true,
                        trans: ''
                    },
                    {
                        lang: 'en',
                        active: true,
                        trans: ''
                    },
                    {
                        lang: 'fr',
                        active: true,
                        trans: ''
                    },
                    {
                        lang: 'ru',
                        active: true,
                        trans: ''
                    },
                    {
                        lang: 'pt',
                        active: true,
                        trans: ''
                    },
                ]
            })
        }

    }, [info])


    const handleTrad = (lang) =>{
        const url = `${process.env.REACT_APP_API_URL}/translation/deepl`; // Reemplaza esta URL por la URL real de la API
        const authorizationHeader = { 'Authorization': `Bearer ${JSON.parse(localStorage?.getItem('user')).token}` }; // Crea el encabezado Authorization

        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                title: info?.translations?.filter(c => c?.lang === 'en')?.[0]?.trans,
                lang
            }),
            headers: {
                'Content-Type': 'application/json',
                ...authorizationHeader // Agrega el encabezado Authorization a los encabezados de solicitud
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error en la respuesta de la API');
            }
            return response.json();
        })
        .then(data => {
            console.log('Respuesta de la API:', data);
            let translation = data?.translations?.[0]?.text
            if(translation){
                setInfo({
                    ...info,
                    translations: [...info?.translations?.filter(c => c?.lang !== lang?.toLowerCase()), {
                        lang: lang?.toLowerCase(),
                        active: info?.translations?.filter(c => c?.lang === lang?.toLowerCase())?.[0]?.active,
                        trans: translation
                    }]
                })
            }
        })
        .catch(error => {
            console.error('Error al llamar a la API:', error);
        });
    }

    const handleGetPinyins = (char) =>{
        const url = `${process.env.REACT_APP_API_URL}/translation/character`; // Reemplaza esta URL por la URL real de la API
        const authorizationHeader = { 'Authorization': `Bearer ${JSON.parse(localStorage?.getItem('user')).token}` }; // Crea el encabezado Authorization

        fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                character: char
            }),
            headers: {
                'Content-Type': 'application/json',
                ...authorizationHeader // Agrega el encabezado Authorization a los encabezados de solicitud
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error en la respuesta de la API');
            }
            return response.json();
        })
        .then(data => {
            console.log('Respuesta de la API:', data);
            if(data?.pinyin){
                setInfo({
                    ...info,
                    pinyin: data?.pinyin,
                    pinyinTone: data?.pinyinTone
                })
            }
        })
        .catch(error => {
            console.error('Error al llamar a la API:', error);
        });
    }

    
    const handleUploadFile = (e) =>{
        setFile(e.target.files?.[0])
        setFileURL(URL.createObjectURL(e.target.files?.[0]))
        setInfo({
            ...info,
            fileExtra: e.target.files?.[0]
        })
    }


    // Split functions

    const characters_ = {
        character: "character",
        lineBreak: "SC",
        special: "SC",
        name: "name",
    };
      
    const SPECIAL_CARDS = [" ", ",", "，", "%", ":", ":", "：", "、"];
    const LINE_BREAK_CARDS = ["。", ".", "!", "！", "?", "？", ";", "；"];
    
    const LANGS = ["en", "es", "fr", "ru", "pt"];

    const { cards } = useSelector((state) => state);

    const [isModalAddCard, setIsModalAddCard] = useState(false);

    const [isModalChangeSpecialCard, setIsModalChangeSpecialCard] = useState(false);

    const [isChangeCard, setIsChangeCard] = useState(false);

    const [selectedCard, setSelectedCard] = useState("");
    const [visibleModal, setVisibleModal] = useState(false);

    const [indiceFraseSelected, setIndiceFraseSelected] = useState(0);
    const [indiceCardSelected, setIndiceCardSelected] = useState(0);

    const handleSearchCard = (e) => {
        dispatch(
          fetchCards({
            take: 5,
            skip: 0,
            search: e,
          })
        );
      };

    const handleMouseEnter = (e, index, i) => {
        try {
          document.getElementById(`card_tooltip_${index}_${i}`).style.display = "block";
        } catch (err) {
          console.log(err);
        }
      };
    
      const handleMouseLeave = (e, index, i) => {
        try {
          document.getElementById(`card_tooltip_${index}_${i}`).style.display = "none";
        } catch (err) {
          console.log(err);
        }
      };

      function extraerNumero(str) {
        const resultado = str.match(/\d+/); // Esta expresión regular busca uno o más dígitos
        return resultado ? parseInt(resultado[0]) : null;
      }

      const handleGetColorLevel = (lvl) => {
        const COLORS = {
          1: "#83BF6E",
          2: "#78CEFF",
          3: "#5E5BF6",
          4: "#EDE63E",
          5: "#F0B43F",
          6: "#F05D5D",
          7: "#C055E5",
        };
    
        if (lvl?.title) {
          return COLORS?.[extraerNumero(lvl?.title)] || "#d3d3d3";
        } else {
          return "#d3d3d3";
        }
      };

      const anadirCardAFrase = (indiceFrase, nuevoCard) => {
        setInfo(prevInfo => ({
            ...prevInfo,
            analyzed: {
                ...prevInfo?.analyzed,
                content: prevInfo?.analyzed?.content?.map((content, index) => {
                    if (index === 0) {
                        return {
                            ...content,
                            sentences: content?.sentences?.map((frase, idx) => {
                                if (idx === indiceFrase) {
                                    return { ...frase, cards: [...(frase.cards || []), nuevoCard] };
                                }
                                return frase;
                            })
                        };
                    }
                    return content;
                })
            }
        }));
    };

    const eliminarCardDeFrase = (indiceFrase, indiceCard) => {
        setInfo(prevInfo => ({
            ...prevInfo,
            analyzed: {
                ...prevInfo?.analyzed,
                content: prevInfo?.analyzed?.content?.map((content, index) => {
                    if (index === 0) {
                        return {
                            ...content,
                            sentences: content?.sentences?.map((frase, idx) => {
                                if (idx === indiceFrase) {
                                    const nuevosCards = frase.cards?.filter((_, i) => i !== indiceCard);
                                    return { ...frase, cards: nuevosCards };
                                }
                                return frase;
                            })
                        };
                    }
                    return content;
                })
            }
        }));
    };

    const cambiarCardDeFrase = (indiceFrase, indiceCard, nuevaCard) => {
        setInfo(prevInfo => ({
            ...prevInfo,
            analyzed: {
                ...prevInfo?.analyzed,
                content: prevInfo?.analyzed?.content?.map((content, index) => {
                    if (index === 0) {
                        return {
                            ...content,
                            sentences: content?.sentences?.map((frase, idx) => {
                                if (idx === indiceFrase) {
                                    const cardsActualizadas = frase.cards?.map((card, indexC) => {
                                        if (indexC === indiceCard) {
                                            return { ...card, ...nuevaCard };
                                        }
                                        return card;
                                    });
                                    return { ...frase, cards: cardsActualizadas };
                                }
                                return frase;
                            })
                        };
                    }
                    return content;
                })
            }
        }));
    };

    const anadirCardDespuesDeOtra = (indiceFrase, indiceCard, nuevaCard) => {
        setInfo(prevInfo => ({
            ...prevInfo,
            analyzed: {
                ...prevInfo?.analyzed,
                content: prevInfo?.analyzed?.content?.map((content, index) => {
                    if (index === 0) {
                        return {
                            ...content,
                            sentences: content?.sentences?.map((frase, idx) => {
                                if (idx === indiceFrase) {
                                    const cardsActualizadas = [
                                        ...frase.cards.slice(0, indiceCard + 1),
                                        nuevaCard,
                                        ...frase.cards.slice(indiceCard + 1)
                                    ];
                                    return { ...frase, cards: cardsActualizadas };
                                }
                                return frase;
                            })
                        };
                    }
                    return content;
                })
            }
        }));
    };

    return (
        <div>
            <Modal visible={visibleModalImportText} onClose={() => setVisibleModalImportText(false)}>
                <div>
                <div style={{ fontSize: 18 }}>Import text</div>
                <div className={styles.modalDivider} />
                <div style={{ marginTop: 25 }}>
                    <label className={styles.modalLabel}>Short description</label>
                    <textarea
                    rows="30"
                    style={{ height: "200px" }}
                    value={textImport}
                    onChange={(e) => {
                        setTextImport(e.target.value)
                        setInfo({
                            ...info,
                            analyzed: {
                                ...info.analyzed,
                                text: e.target.value,
                                processRawText: true
                            }
                        })
                    }}
                    className={styles.input}
                    placeholder="Write here..."
                    ></textarea>
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    <button onClick={()=>setVisibleModalImportText(false)} className={classNames("button-black button-small", styles.favorite)}>
                    Import
                    </button>
                </div>
                </div>
            </Modal>
            <Modal outerClassName={styles.outer} visible={visibleModal} onClose={() => setVisibleModal(false)}>
                <div>
                <CardPreview card={selectedCard} />
                </div>
            </Modal>
            <Modal
                outerClassName={styles.outer}
                visible={isModalChangeSpecialCard}
                onClose={() => setIsModalChangeSpecialCard(false)}
            >
                <div>Select Special Char</div>
                <div
                className={classNames(styles.listSentence, styles.specialCharsGrid)}
                >
                {SPECIAL_CARDS?.map((c, i) => (
                    <div
                    onClick={() => {
                        cambiarCardDeFrase(indiceFraseSelected, indiceCardSelected, {
                        available: false,
                        card: null,
                        character: c,
                        suggestions: [],
                        type: "special",
                        });
                        setIsModalChangeSpecialCard(false);
                    }}
                    key={i}
                    style={{ position: "relative" }}
                    >
                    <div tabindex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                        <div className={styles.charLevelBar}></div>
                        <div className={styles.charSubText}>
                        SC
                        </div>
                        <div className={styles.charMainText}>
                        {c}
                        </div>
                    </div>
                    </div>
                ))}
                {LINE_BREAK_CARDS?.map((c, i) => (
                    <div
                    onClick={() => {
                        cambiarCardDeFrase(indiceFraseSelected, indiceCardSelected, {
                        available: false,
                        card: null,
                        character: c,
                        suggestions: [],
                        type: "lineBreak",
                        });
                        setIsModalChangeSpecialCard(false);
                    }}
                    key={i}
                    style={{ position: "relative" }}
                    >
                    <div tabindex={i} style={{ transform: i === 0 ? "translateY(0.45em)" : "" }} className={styles.charCard}>
                        <div className={styles.charLevelBar}></div>
                        <div className={styles.charSubText}>
                        SC
                        </div>
                        <div className={styles.charMainText}>
                        {c}
                        </div>
                    </div>
                    </div>
                ))}
                </div>
            </Modal>
            <Modal outerClassName={styles.outer} visible={isModalAddCard} onClose={() => setIsModalAddCard(false)}>
                <div>
                <TextInput
                    type="text"
                    required
                    placeholder="Search card..."
                    onChange={(e) => handleSearchCard(e.target.value)}
                />
                {cards?.value?.map((c, i) => (
                    <div key={i} className={styles.searchResultItem}>
                    <div style={{ display: "flex", alignItems: "start" }}>
                        <div className={styles.searchCharBox}>
                        {c?.meaning?.character}
                        </div>
                        <div style={{ marginLeft: 20, width: "200px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <b>{c?.meaning?.pinyin}</b>
                            <span className={styles.searchTone}>{c?.meaning?.pinyinTone}</span>
                        </div>
                        <div className={styles.searchTrans}>{c?.meaning?.trans}</div>
                        </div>
                    </div>
                    <span
                        onClick={() => {
                        if (isChangeCard) {
                            cambiarCardDeFrase(indiceFraseSelected, indiceCardSelected, {
                                available: true,
                                card: c,
                                character: c?.meaning?.character,
                                suggestions: [],
                            });
                        } else {
                            anadirCardDespuesDeOtra(indiceFraseSelected, indiceCardSelected, {
                                available: true,
                                card: c,
                                character: c?.meaning?.character,
                                suggestions: [],
                            });
                        }
                        setIsModalAddCard(false);
                        }}
                        className={styles.searchAddBtn}
                    >
                        {isChangeCard ? "Change" : "+ Add"}
                    </span>
                    </div>
                ))}
                </div>
            </Modal>
            {info?.analyzed && (
                <div style={{ marginBottom: 25 }}>
                    <div className={styles.splitHeader}>
                        <div>
                            Splited text
                        </div>
                        <div>
                            {info?.analyzed?.processRawText ? (
                                <button className={styles.importBtn} onClick={() => setVisibleModalImportText(true)}>Text Imported (edit)</button>
                            ) : (
                                <button className={styles.importBtn} onClick={() => setVisibleModalImportText(true)}>+ Import text</button>
                            )}
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        {info?.analyzed?.content?.[0]?.sentences?.map((sentence, index) => (
                            <>
                            <div
                                ref={(el) => (myRefs.current[index] = el)}
                                key={index}
                                className={classNames(styles.listSentence, styles.chipsContainer)}
                            >
                            {sentence?.cards?.map((c, i) => (
                                <div
                                    key={i}
                                    onMouseEnter={(e) => handleMouseEnter(e, index, i)}
                                    onMouseLeave={(e) => handleMouseLeave(e, index, i)}
                                    style={{ position: "relative" }}
                                >
                                <div
                                    id={`card_tooltip_${index}_${i}`}
                                    className={styles.cardTooltip}
                                >
                                    <div
                                    style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                                    >
                                    <div className={styles.tooltipLabel}>TP</div>
                                    <div style={{ color: c?.card?.grammars?.[0]?.title ? "inherit" : "#FF6A55" }}>
                                        {c?.card?.grammars?.[0]?.title || "Err"}
                                    </div>
                                    </div>
                                    <div
                                    style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                                    >
                                    <div className={styles.tooltipLabel}>TR</div>
                                    <div
                                        style={{
                                        color: c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans
                                            ? "inherit"
                                            : "#FF6A55",
                                        }}
                                    >
                                        {c?.card?.meaning?.translations?.find((trans) => trans?.lang === "en")?.trans || "Err"}
                                    </div>
                                    </div>
                                    <div
                                    style={{ display: "flex", fontSize: 14, alignItems: "center", justifyContent: "space-between" }}
                                    >
                                    <div className={styles.tooltipLabel}>Level</div>
                                    <div style={{ color: c?.level?.title ? "inherit" : "#FF6A55" }}>{c?.level?.title || "Err"}</div>
                                    </div>
                                </div>
                                <Popover2
                                    actionable={
                                    <div
                                        tabindex={i}
                                        style={{ transform: i === 0 ? "translateY(0.45em)" : "" }}
                                        className={styles.charCard}
                                    >
                                        <div
                                            className={styles.charLevelBar}
                                            style={{ backgroundColor: handleGetColorLevel(c?.level) || "#d3d3d3" }}
                                        ></div>
                                        <div
                                            className={styles.charSubText}
                                            style={{
                                            color:
                                                c?.type === "name"
                                                ? "#7B61FF"
                                                : c?.card?.meaning?.pinyin
                                                ? "#A1A1A1"
                                                : c?.type === "special" || c?.type === "lineBreak"
                                                ? "#A1A1A1"
                                                : "#FF6A55",
                                            }}
                                        >
                                            {c?.card?.meaning?.pinyin || characters_?.[c?.type] || "Err"}
                                        </div>
                                        <div
                                        className={styles.charMainText}
                                        >
                                        {c?.character}
                                        </div>
                                    </div>
                                    }
                                    items={[
                                    {
                                        title: "Preview card",
                                        icon: "expand",
                                        action: () => {
                                            setSelectedCard(c?.card);
                                            setVisibleModal(true);
                                        },
                                    },
                                    {
                                        title: "Edit card",
                                        icon: "edit",
                                        action: () => {
                                            setIsChangeCard(true);
                                            setIndiceFraseSelected(index);
                                            setIndiceCardSelected(i);
                                            setIsModalAddCard(true);
                                        },
                                    },
                                    {
                                        title: "Convert Special",
                                        icon: "edit",
                                        action: () => {
                                            setIndiceFraseSelected(index);
                                            setIndiceCardSelected(i);
                                            setIsModalChangeSpecialCard(true);
                                        },
                                    },
                                    {
                                        title: "Convert Noun",
                                        icon: "edit",
                                        action: () => {
                                        cambiarCardDeFrase(index, i, {
                                            available: false,
                                            card: null,
                                            character: `##${c?.character}##`,
                                            suggestions: [],
                                            type: "name",
                                        });
                                        },
                                    },
                                    {
                                        title: "Delete card",
                                        icon: "trash",
                                        action: () => eliminarCardDeFrase(index, i),
                                    },
                                    {
                                        title: "Add next card",
                                        icon: "add",
                                        action: () => {
                                        setIsChangeCard(false);
                                        setIndiceFraseSelected(index);
                                        setIndiceCardSelected(i);
                                        setIsModalAddCard(true);
                                        },
                                    },
                                    ]}
                                />
                                </div>
                            ))}
                            <Popover
                                title="Suggested word"
                                actionable={<span className={styles.addCharLink}>+ Add char</span>}
                            >
                                <div>
                                <TextInput
                                    type="text"
                                    required
                                    placeholder="Search card..."
                                    onChange={(e) => handleSearchCard(e.target.value)}
                                />
                                {cards?.value?.map((c, i) => (
                                    <div key={i} className={styles.searchResultItem}>
                                    <div style={{ display: "flex", alignItems: "start" }}>
                                        <div className={styles.searchCharBox}>
                                        {c?.meaning?.character}
                                        </div>
                                        <div style={{ marginLeft: 20, width: "200px" }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <b>{c?.meaning?.pinyin}</b>
                                            <span className={styles.searchTone}>{c?.meaning?.pinyinTone}</span>
                                        </div>
                                        <div className={styles.searchTrans}>{c?.meaning?.trans}</div>
                                        </div>
                                    </div>
                                    <span
                                        onClick={() =>
                                        anadirCardAFrase(index, {
                                            available: true,
                                            card: c,
                                            character: c?.meaning?.character,
                                            suggestions: [],
                                        })
                                        }
                                        className={styles.searchAddBtn}
                                    >
                                        + Add
                                    </span>
                                    </div>
                                ))}
                                </div>
                            </Popover>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 10 }}>
                                <Switch
                                    className={styles.switch}
                                    value={isContextValidated}
                                    onChange={() => {
                                        setIsContextValidated(!isContextValidated)
                                        setInfo({
                                            ...info,
                                            analyzed: {
                                                ...info.analyzed,
                                                active: !isContextValidated
                                            }
                                        })
                                    }}
                                />
                                <span>
                                    <span className={styles.validatedLabel}>Context validated</span>
                                    {contextValidatedBy && (
                                        <span className={styles.validatedMeta}>(by {contextValidatedBy} {dayjs(contextValidatedAt).format('MMM DD, YYYY - HH:mm[h]')})</span>
                                    )}
                                </span>
                            </div>
                            </>
                        ))}
                    </div>
                </div>
            )}
            <TextInput
                name="Characters"
                type="text"
                label="Characters"
                disabled={info?.analyzed}
                tooltip="Small description"
                required
                value={characters}
                style={{
                    opacity: info?.analyzed ? 0.5 : 1
                }}
                onChange={(e)=>{
                    setInfo({
                        ...info,
                        character: e.target.value
                    })
                }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 25 }} >
                <div style={{ width: '100%', marginBottom: 10, position: 'relative' }}>
                    <TextInput
                        name="Pinyin"
                        type="text"
                        label="Pinyin"
                        tooltip="Small description"
                        required
                        value={pinyin}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                pinyin: e.target.value
                            })
                        }}
                    />
                    <div style={{position: 'absolute', right: 20, top:20, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleGetPinyins(characters)} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={pinyinActive}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    pinyinExample: {
                                        ...info.pinyinExample,
                                        active: !pinyinActive
                                    }
                                })
                            }}
                        />
                    </div>
                </div>
                <div style={{ width: '100%', marginTop: 10, marginBottom: 10, position: 'relative' }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        label="Tone"
                        tooltip="Small description"
                        required
                        value={tone}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                pinyinTone: e.target.value
                            })
                        }}
                    />
                    <div style={{position: 'absolute', right: 20, top:20, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleGetPinyins(characters)} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={toneActive}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    pinyinToneExample: {
                                        ...info.pinyinToneExample,
                                        active: !toneActive
                                    }
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.inputsField}>
                <div style={{
                    position: 'relative'
                }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        tooltip="Small description"
                        required
                        currency="EN"
                        defaultValue={tradEN}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                translations: [...info?.translations?.filter(c => c?.lang !== 'en'), {
                                    trans: e.target.value,
                                    lang: "en",
                                    active: info?.translations?.filter(c => c?.lang === 'en')?.[0]?.active
                                }]
                            })
                        }}
                    />
                    {/* <div style={{ position: 'absolute', right: 20, top:0, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleTrad('EN')} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={activeEN}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    translations: [...info?.translations?.filter(c => c?.lang !== 'en'), {
                                        lang: "en",
                                        active: info?.translations?.filter(c => c?.lang === 'en')?.[0]?.active ? false : true,
                                        trans: info?.translations?.filter(c => c?.lang === 'en')?.[0]?.trans
                                    }]
                                })
                            }}
                        />
                    </div> */}
                </div>
                <div style={{
                    position: 'relative'
                }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        tooltip="Small description"
                        required
                        currency="ES"
                        defaultValue={tradES}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                translations: [...info?.translations?.filter(c => c?.lang !== 'es'), {
                                    trans: e.target.value,
                                    lang: "es",
                                    active: info?.translations?.filter(c => c?.lang === 'es')?.[0]?.active
                                }]
                            })
                        }}
                    />
                    <div style={{ position: 'absolute', right: 20, top:0, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleTrad('ES')} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={activeES}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    translations: [...info?.translations?.filter(c => c?.lang !== 'es'), {
                                        trans: info?.translations?.filter(c => c?.lang === 'es')?.[0]?.trans,
                                        lang: "es",
                                        active: info?.translations?.filter(c => c?.lang === 'es')?.[0]?.active ? false : true,
                                    }]
                                })
                            }}
                        />
                    </div>
                </div>
                <div style={{
                    position: 'relative'
                }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        tooltip="Small description"
                        required
                        currency="FR"
                        defaultValue={tradFR}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                translations: [...info?.translations?.filter(c => c?.lang !== 'fr'), {
                                    trans: e.target.value,
                                    lang: "fr",
                                    active: info?.translations?.filter(c => c?.lang === 'fr')?.[0]?.active,
                                }]
                            })
                        }}
                    />
                    <div style={{ position: 'absolute', right: 20, top:0, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleTrad('FR')} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={activeFR}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    translations: [...info?.translations?.filter(c => c?.lang !== 'fr'), {
                                        trans: info?.translations?.filter(c => c?.lang === 'fr')?.[0]?.trans,
                                        lang: "fr",
                                        active: info?.translations?.filter(c => c?.lang === 'fr')?.[0]?.active ? false : true,
                                    }]
                                })
                            }}
                        />
                    </div>
                </div>
                <div style={{
                    position: 'relative'
                }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        tooltip="Small description"
                        required
                        currency="RU"
                        defaultValue={tradRU}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                translations: [...info?.translations?.filter(c => c?.lang !== 'ru'), {
                                    trans: e.target.value,
                                    lang: "ru",
                                    active: info?.translations?.filter(c => c?.lang === 'ru')?.[0]?.active,
                                }]
                            })
                        }}
                    />
                    <div style={{ position: 'absolute', right: 20, top:0, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleTrad('RU')} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={activeRU}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    translations: [...info?.translations?.filter(c => c?.lang !== 'ru'), {
                                        trans: info?.translations?.filter(c => c?.lang === 'ru')?.[0]?.trans,
                                        lang: "ru",
                                        active: info?.translations?.filter(c => c?.lang === 'ru')?.[0]?.active ? false : true,
                                    }]
                                })
                            }}
                        />
                    </div>
                </div>
                <div style={{
                    position: 'relative'
                }}>
                    <TextInput
                        name="Tone"
                        type="text"
                        tooltip="Small description"
                        required
                        currency="PT"
                        defaultValue={tradPT}
                        onChange={(e)=>{
                            setInfo({
                                ...info,
                                translations: [...info?.translations?.filter(c => c?.lang !== 'pt'), {
                                    trans: e.target.value,
                                    lang: "pt",
                                    active: info?.translations?.filter(c => c?.lang === 'pt')?.[0]?.active,
                                }]
                            })
                        }}
                    />
                    <div style={{ position: 'absolute', right: 20, top:0, height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <button onClick={()=>handleTrad('PT')} style={{ marginRight: 20 }}>
                            <FiRepeat size="20" />
                        </button>
                        <Switch 
                            value={activePT}
                            onChange={() => {
                                setInfo({
                                    ...info,
                                    translations: [...info?.translations?.filter(c => c?.lang !== 'pt'), {
                                        trans: info?.translations?.filter(c => c?.lang === 'pt')?.[0]?.trans,
                                        lang: "pt",
                                        active: info?.translations?.filter(c => c?.lang === 'pt')?.[0]?.active ? false : true,
                                    }]
                                })
                            }}
                        />
                    </div>
                </div>
            </div>
            {(info?.videoOld || info?.videoUrl || file) ? (
                    <div className={styles.videoContainer}>
                        <video src={info?.videoOld || info?.videoUrl || fileURL} style={{ width: '350px', borderRadius: '12px'}} controls />
                        <div className={styles.videoTitle}>
                            {file?.name || "Video .mp4"}
                        </div>
                        <button className={styles.videoDelete} onClick={()=>{
                            setFile('')

                            setInfo({
                                ...info,
                                videoOld: '',
                                videoUrl: '',
                                fileExtra: ''
                            })
                        }} >
                            Delete
                        </button>
                    </div>
                ) : (
                <div style={{ marginTop: 25 }}>
                    <File
                        className={styles.field}
                        onChange={handleUploadFile}
                        title="Click or drop video"
                        label="Upload video"
                        tooltip="Maximum 100 characters. No HTML or emoji allowed"
                    />
                </div>
            )}
        </div>
    );
}

export default ContextInfo;